var render = function(_h, _vm) {
  var _c = _vm._c
  return _c(
    "svg",
    _vm._g(
      _vm._b(
        {
          ref: _vm.data.ref,
          class: [_vm.data.class, _vm.data.staticClass],
          style: [_vm.data.style, _vm.data.staticStyle],
          attrs: {
            version: "1.1",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink"
          }
        },
        "svg",
        _vm.data.attrs,
        false
      ),
      _vm.listeners
    ),
    [
      _c("defs", [
        _c("path", { attrs: { id: _vm.props.pathId, d: "M0,0h2v6h-2Z" } })
      ]),
      _vm._v(" "),
      _c("g", { attrs: { fill: "none" } }, [
        _c("path", {
          attrs: { d: "M0,0h24v24h-24Z", transform: "translate(0, 0.002)" }
        })
      ]),
      _vm._v(" "),
      _c("g", [
        _c("path", {
          attrs: {
            d:
              "M19,4h-1v-1h-2v1h-2v-3c0,-0.552 -0.447,-1 -1,-1h-6c-0.553,0 -1,0.448 -1,1v3h-2v-1h-2v1h-1c-0.553,0 -1,0.448 -1,1v12c0,0.552 0.447,1 1,1h18c0.553,0 1,-0.448 1,-1v-12c0,-0.551 -0.447,-1 -1,-1Zm-11,-1h4v1h-4v-1Zm10,13h-16v-10h5h6h5v10Z",
            transform: "translate(2, 3.001)"
          }
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { transform: "translate(6, 11.001)", "xlink:href": "#path-1" }
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { transform: "translate(11, 11.001)", "xlink:href": "#path-1" }
        }),
        _vm._v(" "),
        _c("use", {
          attrs: { transform: "translate(16, 11.001)", "xlink:href": "#path-1" }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }